import { __styles } from '@griffel/react';
export const useStyles = __styles({
  root: {
    mc9l5x: "f1w7gpdv",
    Bg96gwp: "fez10in"
  },
  rtl: {
    Bz10aip: "f13rod7r"
  }
}, {
  d: [".f1w7gpdv{display:inline;}", ".fez10in{line-height:0;}", ".f13rod7r{transform:scaleX(-1);}"]
});